import {
  FETCHED_ALL_MATCHES,
  CLEAR_MATCHES,
  RETURN_MATCHES_ERROR,
} from "../actions/types";

const tempAllMatches = sessionStorage.getItem("all_matches");

const INITIAL_STATE = {
  all_matches: tempAllMatches ? JSON.parse(tempAllMatches) : null,
  m_error_msg: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHED_ALL_MATCHES:
      return { ...state, all_matches: action.payload };
    case CLEAR_MATCHES:
      return { ...state, all_matches: null };
    case RETURN_MATCHES_ERROR:
      return { ...state, m_error_msg: action.payload };
    default:
      return state;
  }
};
